module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "coupon-icon.767c80da.png";